const actions = {
  RESET_ACCOUNT_OFFICER_REDUX: 'RESET_ACCOUNT_OFFICER_REDUX',
  SELECT_CALENDAR_DATE: 'SELECT_CALENDAR_DATE',
  IS_PAST_DATE: 'IS_PAST_DATE',

  FETCH_ACCOUNT_OFFICER_DATA: 'FETCH_ACCOUNT_OFFICER_DATA',
  FETCHING_ACCOUNT_OFFICER_DATA: 'FETCHING_ACCOUNT_OFFICER_DATA',
  FETCH_ACCOUNT_OFFICER_DATA_SUCCESS: 'FETCH_ACCOUNT_OFFICER_DATA_SUCCESS',
  FETCH_ACCOUNT_OFFICER_DATA_FAILED: 'FETCH_ACCOUNT_OFFICER_DATA_FAILED',

  FETCH_MERCHANT_STATUS_COUNT_DATA: 'FETCH_MERCHANT_STATUS_COUNT_DATA',
  FETCHING_MERCHANT_STATUS_COUNT_DATA: 'FETCHING_MERCHANT_STATUS_COUNT_DATA',
  FETCH_MERCHANT_STATUS_COUNT_DATA_SUCCESS: 'FETCH_MERCHANT_STATUS_COUNT_DATA_SUCCESS',
  FETCH_MERCHANT_STATUS_COUNT_DATA_FAILED: 'FETCH_MERCHANT_STATUS_COUNT_DATA_FAILED',

  FETCH_ACCOUNT_OFFICER_TEAM_DATA: 'FETCH_ACCOUNT_OFFICER_TEAM_DATA',
  FETCHING_ACCOUNT_OFFICER_TEAM_DATA: 'FETCHING_ACCOUNT_OFFICER_TEAM_DATA',
  FETCH_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS: 'FETCH_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS',
  FETCH_ACCOUNT_OFFICER_TEAM_DATA_FAILED: 'FETCH_ACCOUNT_OFFICER_TEAM_DATA_FAILED',

  FETCH_ALL_MERCHANT_DATA: 'FETCH_ALL_MERCHANT_DATA',
  FETCHING_ALL_MERCHANT_DATA: 'FETCHING_ALL_MERCHANT_DATA',
  FETCH_ALL_MERCHANT_DATA_SUCCESS: 'FETCH_ALL_MERCHANT_DATA_SUCCESS',
  FETCH_ALL_MERCHANT_DATA_FAILED: 'FETCH_ALL_MERCHANT_DATA_FAILED',

  ADD_ACCOUNT_OFFICER_DATA: 'ADD_ACCOUNT_OFFICER_DATA',
  ADDING_ACCOUNT_OFFICER_DATA: 'ADDING_ACCOUNT_OFFICER_DATA',
  ADD_ACCOUNT_OFFICER_DATA_SUCCESS: 'ADD_ACCOUNT_OFFICER_DATA_SUCCESS',
  ADD_ACCOUNT_OFFICER_DATA_FAILED: 'ADD_ACCOUNT_OFFICER_DATA_FAILED',

  ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA: 'ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA',
  ADDING_NEW_ACCOUNT_OFFICER_TEAM_DATA: 'ADDING_NEW_ACCOUNT_OFFICER_TEAM_DATA',
  ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS: 'ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS',
  ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED: 'ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA_FAILED',

  EDIT_ACCOUNT_OFFICER_DATA: 'EDIT_ACCOUNT_OFFICER_DATA',
  EDITING_ACCOUNT_OFFICER_DATA: 'EDITING_ACCOUNT_OFFICER_DATA',
  EDIT_ACCOUNT_OFFICER_DATA_SUCCESS: 'EDIT_ACCOUNT_OFFICER_DATA_SUCCESS',
  EDIT_ACCOUNT_OFFICER_DATA_FAILED: 'EDIT_ACCOUNT_OFFICER_DATA_FAILED',

  EDIT_ACCOUNT_OFFICER_TEAM_DATA: 'EDIT_ACCOUNT_OFFICER_TEAM_DATA',
  EDITING_ACCOUNT_OFFICER_TEAM_DATA: 'EDITING_ACCOUNT_OFFICER_TEAM_DATA',
  EDIT_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS: 'EDIT_ACCOUNT_OFFICER_TEAM_DATA_SUCCESS',
  EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED: 'EDIT_ACCOUNT_OFFICER_TEAM_DATA_FAILED',

  DELETE_ACCOUNT_OFFICER_DATA: 'DELETE_ACCOUNT_OFFICER_DATA',
  DELETING_ACCOUNT_OFFICER_DATA: 'DELETING_ACCOUNT_OFFICER_DATA',
  DELETE_ACCOUNT_OFFICER_DATA_SUCCESS: 'DELETE_ACCOUNT_OFFICER_DATA_SUCCESS',
  DELETE_ACCOUNT_OFFICER_DATA_FAILED: 'DELETE_ACCOUNT_OFFICER_DATA_FAILED',

  DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA: 'DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA',
  DELETING_ACCOUNT_OFFICER_ON_TEAM_DATA: 'DELETING_ACCOUNT_OFFICER_ON_TEAM_DATA',
  DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_SUCCESS: 'DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_SUCCESS',
  DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED: 'DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA_FAILED',

  UPDATE_ACCOUNT_OFFICER_STATUS: 'UPDATE_ACCOUNT_OFFICER_STATUS',
  UPDATING_ACCOUNT_OFFICER_STATUS: 'UPDATING_ACCOUNT_OFFICER_STATUS',
  UPDATE_ACCOUNT_OFFICER_STATUS_SUCCESS: 'UPDATE_ACCOUNT_OFFICER_STATUS_SUCCESS',
  UPDATE_ACCOUNT_OFFICER_STATUS_FAILED: 'UPDATE_ACCOUNT_OFFICER_STATUS_FAILED',

  FETCH_LEAD_MANAGEMENT_LIST_DATA: 'FETCH_LEAD_MANAGEMENT_LIST_DATA',
  FETCHING_LEAD_MANAGEMENT_LIST_DATA: 'FETCHING_LEAD_MANAGEMENT_LIST_DATA',
  FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS: 'FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS',
  FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED: 'FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED',

  FETCH_LEAD_MANAGEMENT_LIST_DATA_BY_MQTT: 'FETCH_LEAD_MANAGEMENT_LIST_DATA_BY_MQTT',
  FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS_BY_MQTT:
    'FETCH_LEAD_MANAGEMENT_LIST_DATA_SUCCESS_BY_MQTT',
  FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED_BY_MQTT: 'FETCH_LEAD_MANAGEMENT_LIST_DATA_FAILED_BY_MQTT',

  FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA: 'FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA',
  FETCHING_FILTERED_LEAD_MANAGEMENT_LIST_DATA: 'FETCHING_FILTERED_LEAD_MANAGEMENT_LIST_DATA',
  FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_SUCCESS:
    'FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_SUCCESS',
  FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_FAILED:
    'FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA_FAILED',

  FETCH_LEAD_MANAGEMENT_CALENDAR_DATA: 'FETCH_LEAD_MANAGEMENT_CALENDAR_DATA',
  FETCHING_LEAD_MANAGEMENT_CALENDAR_DATA: 'FETCHING_LEAD_MANAGEMENT_CALENDAR_DATA',
  FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_SUCCESS: 'FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_SUCCESS',
  FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_FAILED: 'FETCH_LEAD_MANAGEMENT_CALENDAR_DATA_FAILED',

  FETCH_LEAD_MANAGEMENT_REPORT_DATA: 'FETCH_LEAD_MANAGEMENT_REPORT_DATA',
  FETCHING_LEAD_MANAGEMENT_REPORT_DATA: 'FETCHING_LEAD_MANAGEMENT_REPORT_DATA',
  FETCH_LEAD_MANAGEMENT_REPORT_DATA_SUCCESS: 'FETCH_LEAD_MANAGEMENT_REPORT_DATA_SUCCESS',
  FETCH_LEAD_MANAGEMENT_REPORT_DATA_FAILED: 'FETCH_LEAD_MANAGEMENT_REPORT_DATA_FAILED',

  UPDATE_LEAD_MERCHANT_LIST_DATA: 'UPDATE_LEAD_MERCHANT_LIST_DATA',
  UPDATING_LEAD_MERCHANT_LIST_DATA: 'UPDATING_LEAD_MERCHANT_LIST_DATA',
  UPDATE_LEAD_MERCHANT_LIST_DATA_SUCCESS: 'UPDATE_LEAD_MERCHANT_LIST_DATA_SUCCESS',
  UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED: 'UPDATE_LEAD_MERCHANT_LIST_DATA_FAILED',

  ADD_LEAD_MERCHANT_DATA: 'ADD_LEAD_MERCHANT_DATA',
  ADDING_LEAD_MERCHANT_DATA: 'ADDING_LEAD_MERCHANT_DATA',
  ADD_LEAD_MERCHANT_DATA_SUCCESS: 'ADD_LEAD_MERCHANT_DATA_SUCCESS',
  ADD_LEAD_MERCHANT_DATA_FAILED: 'ADD_LEAD_MERCHANT_DATA_FAILED',

  ADD_FARMING_LEAD_MERCHANT_DATA: 'ADD_FARMING_LEAD_MERCHANT_DATA',
  ADDING_FARMING_LEAD_MERCHANT_DATA: 'ADDING_FARMING_LEAD_MERCHANT_DATA',
  ADD_FARMING_LEAD_MERCHANT_DATA_SUCCESS: 'ADD_FARMING_LEAD_MERCHANT_DATA_SUCCESS',
  ADD_FARMING_LEAD_MERCHANT_DATA_FAILED: 'ADD_FARMING_LEAD_MERCHANT_DATA_FAILED',

  ADD_APPOINTMENT_DATA: 'ADD_APPOINTMENT_DATA',
  ADDING_APPOINTMENT_DATA: 'ADDING_APPOINTMENT_DATA',
  ADD_APPOINTMENT_DATA_SUCCESS: 'ADD_APPOINTMENT_DATA_SUCCESS',
  ADD_APPOINTMENT_DATA_FAILED: 'ADD_APPOINTMENT_DATA_FAILED',

  EDIT_APPOINTMENT_DATA: 'EDIT_APPOINTMENT_DATA',
  EDITING_APPOINTMENT_DATA: 'EDITING_APPOINTMENT_DATA',
  EDIT_APPOINTMENT_DATA_SUCCESS: 'EDIT_APPOINTMENT_DATA_SUCCESS',
  EDIT_APPOINTMENT_DATA_FAILED: 'EDIT_APPOINTMENT_DATA_FAILED',

  FETCH_TARGET_PROJECTIONS_DATA: 'FETCH_TARGET_PROJECTIONS_DATA',
  FETCHING_TARGET_PROJECTIONS_DATA: 'FETCHING_TARGET_PROJECTIONS_DATA',
  FETCH_TARGET_PROJECTIONS_DATA_SUCCESS: 'FETCH_TARGET_PROJECTIONS_DATA_SUCCESS',
  FETCH_TARGET_PROJECTIONS_DATA_FAILED: 'FETCH_TARGET_PROJECTIONS_DATA_FAILED',

  FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM: 'FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM',
  FETCHING_TARGET_PROJECTIONS_DATA_BY_TEAM: 'FETCHING_TARGET_PROJECTIONS_DATA_BY_TEAM',
  FETCH_TARGET_PROJECTIONS_DATA_SUCCESS_BY_TEAM: 'FETCH_TARGET_PROJECTIONS_DATA_SUCCESS_BY_TEAM',
  FETCH_TARGET_PROJECTIONS_DATA_FAILED_BY_TEAM: 'FETCH_TARGET_PROJECTIONS_DATA_FAILED_BY_TEAM',

  RESET_TARGET_PROJECTIONS_DATA: 'RESET_TARGET_PROJECTIONS_DATA',

  ADD_MONTHLY_TARGET_DATA: 'ADD_MONTHLY_TARGET_DATA',
  ADDING_MONTHLY_TARGET_DATA: 'ADDING_MONTHLY_TARGET_DATA',
  ADD_MONTHLY_TARGET_DATA_SUCCESS: 'ADD_MONTHLY_TARGET_DATA_SUCCESS',
  ADD_MONTHLY_TARGET_DATA_FAILED: 'ADD_MONTHLY_TARGET_DATA_FAILED',

  ADD_CUSTOMER_VISIT_DATA: 'ADD_CUSTOMER_VISIT_DATA',
  ADDING_CUSTOMER_VISIT_DATA: 'ADDING_CUSTOMER_VISIT_DATA',
  ADD_CUSTOMER_VISIT_DATA_SUCCESS: 'ADD_CUSTOMER_VISIT_DATA_SUCCESS',
  ADD_CUSTOMER_VISIT_DATA_FAILED: 'ADD_CUSTOMER_VISIT_DATA_FAILED',

  UPDATE_MONTHLY_TARGET_DATA: 'UPDATE_MONTHLY_TARGET_DATA',
  UPDATING_MONTHLY_TARGET_DATA: 'UPDATING_MONTHLY_TARGET_DATA',
  UPDATE_MONTHLY_TARGET_DATA_SUCCESS: 'UPDATE_MONTHLY_TARGET_DATA_SUCCESS',
  UPDATE_MONTHLY_TARGET_DATA_FAILED: 'UPDATE_MONTHLY_TARGET_DATA_FAILED',

  UPDATE_CUSTOMER_VISIT_DATA: 'UPDATE_CUSTOMER_VISIT_DATA',
  UPDATING_CUSTOMER_VISIT_DATA: 'UPDATING_CUSTOMER_VISIT_DATA',
  UPDATE_CUSTOMER_VISIT_DATA_SUCCESS: 'UPDATE_CUSTOMER_VISIT_DATA_SUCCESS',
  UPDATE_CUSTOMER_VISIT_DATA_FAILED: 'UPDATE_CUSTOMER_VISIT_DATA_FAILED',

  COMPLETE_MERCHANT_DETAILS: 'COMPLETE_MERCHANT_DETAILS',
  COMPLETING_MERCHANT_DETAILS: 'COMPLETING_MERCHANT_DETAILS',
  COMPLETE_MERCHANT_DETAILS_SUCCESS: 'COMPLETE_MERCHANT_DETAILS_SUCCESS',
  COMPLETE_MERCHANT_DETAILS_FAILED: 'COMPLETE_MERCHANT_DETAILS_FAILED',

  COMPLETE_FARMING_MERCHANT_DETAILS: 'COMPLETE_FARMING_MERCHANT_DETAILS',
  COMPLETING_FARMING_MERCHANT_DETAILS: 'COMPLETING_FARMING_MERCHANT_DETAILS',
  COMPLETE_FARMING_MERCHANT_DETAILS_SUCCESS: 'COMPLETE_FARMING_MERCHANT_DETAILS_SUCCESS',
  COMPLETE_FARMING_MERCHANT_DETAILS_FAILED: 'COMPLETE_FARMING_MERCHANT_DETAILS_FAILED',

  PASS_STATUS_REQUIREMENT_DATA_DATA: 'PASS_STATUS_REQUIREMENT_DATA_DATA',
  PASSING_STATUS_REQUIREMENT_DATA_DATA: 'PASSING_STATUS_REQUIREMENT_DATA_DATA',
  PASS_STATUS_REQUIREMENT_DATA_DATA_SUCCESS: 'PASS_STATUS_REQUIREMENT_DATA_DATA_SUCCESS',
  PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED: 'PASS_STATUS_REQUIREMENT_DATA_DATA_FAILED',

  FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA: 'FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA',
  FETCHING_REQUIREMENT_BY_MERCHANT_ID_DATA: 'FETCHING_REQUIREMENT_BY_MERCHANT_ID_DATA',
  FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_SUCCESS: 'FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_SUCCESS',
  FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED: 'FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA_FAILED',

  FETCH_STORY_BY_MERCHANT_ID_DATA: 'FETCH_STORY_BY_MERCHANT_ID_DATA',
  LOADING_MORE_STORY_BY_MERCHANT_ID_DATA: 'LOADING_MORE_STORY_BY_MERCHANT_ID_DATA',
  FETCHING_STORY_BY_MERCHANT_ID_DATA: 'FETCHING_STORY_BY_MERCHANT_ID_DATA',
  FETCH_STORY_BY_MERCHANT_ID_DATA_SUCCESS: 'FETCH_STORY_BY_MERCHANT_ID_DATA_SUCCESS',
  FETCH_STORY_BY_MERCHANT_ID_DATA_FAILED: 'FETCH_STORY_BY_MERCHANT_ID_DATA_FAILED',
  RESET_STORY_BY_MERCHANT_ID_DATA: 'RESET_STORY_BY_MERCHANT_ID_DATA',

  CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA: 'CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA',
  CHECKING_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA:
    'CHECKING_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA',
  CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_SUCCESS:
    'CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_SUCCESS',
  CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED:
    'CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA_FAILED',

  DOWNLOAD_REQUIREMENT_FILE_DATA: 'DOWNLOAD_REQUIREMENT_FILE_DATA',
  DOWNLOADING_REQUIREMENT_FILE_DATA: 'DOWNLOADING_REQUIREMENT_FILE_DATA',
  DOWNLOAD_REQUIREMENT_FILE_DATA_SUCCESS: 'DOWNLOAD_REQUIREMENT_FILE_DATA_SUCCESS',
  DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED: 'DOWNLOAD_REQUIREMENT_FILE_DATA_FAILED',
  REMOVE_REQUIREMENT_FILE_DATA_STORAGE: 'REMOVE_REQUIREMENT_FILE_DATA_STORAGE',

  ADD_LEADS: 'ADD_LEADS',
  ADDING_LEADS: 'ADDING_LEADS',
  ADD_LEADS_SUCCESS: 'ADD_LEADS_SUCCESS',
  ADD_LEADS_FAILED: 'ADD_LEADS_FAILED',

  ADD_LEADS_BY_RM: 'ADD_LEADS_BY_RM',
  ADDING_LEADS_BY_RM: 'ADDING_LEADS_BY_RM',
  ADD_LEADS_BY_RM_SUCCESS: 'ADD_LEADS_BY_RM_SUCCESS',
  ADD_LEADS_BY_RM_FAILED: 'ADD_LEADS_BY_RM_FAILED',

  ADD_LEADS_FROM_SUSPECTED_DUPLICATES: 'ADD_LEADS_FROM_SUSPECTED_DUPLICATES',
  ADDING_LEADS_FROM_SUSPECTED_DUPLICATES: 'ADDING_LEADS_FROM_SUSPECTED_DUPLICATES',
  ADD_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS: 'ADD_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS',
  ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED: 'ADD_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED',

  REJECT_LEADS_FROM_SUSPECTED_DUPLICATES: 'REJECT_LEADS_FROM_SUSPECTED_DUPLICATES',
  REJECTING_LEADS_FROM_SUSPECTED_DUPLICATES: 'REJECTING_LEADS_FROM_SUSPECTED_DUPLICATES',
  REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS: 'REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_SUCCESS',
  REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED: 'REJECT_LEADS_FROM_SUSPECTED_DUPLICATES_FAILED',

  TOGGLE_LEADS_SUSPECTED_DUPLICATES: 'TOGGLE_LEADS_SUSPECTED_DUPLICATES',

  APPROVE_LEAD_SANITATION: 'APPROVE_LEAD_SANITATION',
  APPROVE_LEAD_SANITATION_LEADS_MANAGEMENT: 'APPROVE_LEAD_SANITATION_LEADS_MANAGEMENT',
  APPROVING_LEAD_SANITATION: 'APPROVING_LEAD_SANITATION',
  APPROVE_LEAD_SANITATION_SUCCESS: 'APPROVE_LEAD_SANITATION_SUCCESS',
  APPROVE_LEAD_SANITATION_FAILED: 'APPROVE_LEAD_SANITATION_FAILED',

  REJECT_LEAD_SANITATION: 'REJECT_LEAD_SANITATION',
  REJECT_LEAD_SANITATION_LEADS_MANAGEMENT: 'REJECT_LEAD_SANITATION_LEADS_MANAGEMENT',
  REJECTING_LEAD_SANITATION: 'REJECTING_LEAD_SANITATION',
  REJECT_LEAD_SANITATION_SUCCESS: 'REJECT_LEAD_SANITATION_SUCCESS',
  REJECT_LEAD_SANITATION_FAILED: 'REJECT_LEAD_SANITATION_FAILED',

  FETCH_ALL_LEADS: 'FETCH_ALL_LEADS',
  FETCHING_ALL_LEADS: 'FETCHING_ALL_LEADS',
  FETCH_ALL_LEADS_SUCCESS: 'FETCH_ALL_LEADS_SUCCESS',
  FETCH_ALL_LEADS_FAILED: 'FETCH_ALL_LEADS_FAILED',
  LOADING_MORE_LEAD_PROFILES: 'LOADING_MORE_LEAD_PROFILES',

  FETCH_ALL_UPLOADED_LEADS_FILE_DATA: 'FETCH_ALL_UPLOADED_LEADS_FILE_DATA',
  FETCHING_ALL_UPLOADED_LEADS_FILE_DATA: 'FETCHING_ALL_UPLOADED_LEADS_FILE_DATA',
  FETCH_ALL_UPLOADED_LEADS_FILE_DATA_SUCCESS: 'FETCH_ALL_UPLOADED_LEADS_FILE_DATA_SUCCESS',
  FETCH_ALL_UPLOADED_LEADS_FILE_DATA_FAILED: 'FETCH_ALL_UPLOADED_LEADS_FILE_DATA_FAILED',

  FETCH_ALL_SUSPECTED_DUPLICATE_LEADS: 'FETCH_ALL_SUSPECTED_DUPLICATE_LEADS',
  FETCHING_ALL_SUSPECTED_DUPLICATE_LEADS: 'FETCHING_ALL_SUSPECTED_DUPLICATE_LEADS',
  FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_SUCCESS: 'FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_SUCCESS',
  FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_FAILED: 'FETCH_ALL_SUSPECTED_DUPLICATE_LEADS_FAILED',

  FETCH_LEADS_BY_ID: 'FETCH_LEADS_BY_ID',
  FETCHING_LEADS_BY_ID: 'FETCHING_LEADS_BY_ID',
  FETCH_LEADS_BY_ID_SUCCESS: 'FETCH_LEADS_BY_ID_SUCCESS',
  FETCH_LEADS_BY_ID_FAILED: 'FETCH_LEADS_BY_ID_FAILED',
  RESET_ACTIVE_LEAD_BY_ID: 'RESET_ACTIVE_LEAD_BY_ID',

  EDIT_LEADS: 'EDIT_LEADS',
  EDITING_LEADS: 'EDITING_LEADS',
  EDIT_LEADS_SUCCESS: 'EDIT_LEADS_SUCCESS',
  EDIT_LEADS_FAILED: 'EDIT_LEADS_FAILED',

  EDIT_LEAD_SANITATION: 'EDIT_LEAD_SANITATION',
  EDITING_LEAD_SANITATION: 'EDITING_LEAD_SANITATION',
  EDIT_LEAD_SANITATION_SUCCESS: 'EDIT_LEADS_SANITATION_SUCCESS',
  EDIT_LEAD_SANITATION_FAILED: 'EDIT_LEAD_SANITATION_FAILED',

  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  FETCH_MERCHANT_SERVICES: 'FETCH_MERCHANT_SERVICES',
  FETCHING_MERCHANT_SERVICES: 'FETCHING_MERCHANT_SERVICES',
  FETCH_MERCHANT_SERVICES_SUCCESS: 'FETCH_MERCHANT_SERVICES_SUCCESS',
  FETCH_MERCHANT_SERVICES_FAILED: 'FETCH_MERCHANT_SERVICES_FAILED',

  FETCH_INSTALLMENT_BANK_CONFIGURATIONS: 'FETCH_INSTALLMENT_BANK_CONFIGURATIONS',
  FETCHING_INSTALLMENT_BANK_CONFIGURATIONS: 'FETCHING_INSTALLMENT_BANK_CONFIGURATIONS',
  FETCH_INSTALLMENT_BANK_CONFIGURATIONS_SUCCESS: 'FETCH_INSTALLMENT_BANK_CONFIGURATIONS_SUCCESS',
  FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED: 'FETCH_INSTALLMENT_BANK_CONFIGURATIONS_FAILED',

  // start: merchant status
  FETCH_MERCHANT_STATUS: 'FETCH_MERCHANT_STATUS',
  FETCHING_MERCHANT_STATUS: 'FETCHING_MERCHANT_STATUS',
  FETCH_MERCHANT_STATUS_SUCCESS: 'FETCH_MERCHANT_STATUS_SUCCESS',
  FETCH_MERCHANT_STATUS_FAILED: 'FETCH_MERCHANT_STATUS_FAILED',

  ADD_MERCHANT_STATUS: 'ADD_MERCHANT_STATUS',
  ADDING_MERCHANT_STATUS: 'ADDING_MERCHANT_STATUS',
  ADD_MERCHANT_STATUS_SUCCESS: 'ADD_MERCHANT_STATUS_SUCCESS',
  ADD_MERCHANT_STATUS_FAILED: 'ADD_MERCHANT_STATUS_FAILED',

  EDIT_MERCHANT_STATUS: 'EDIT_MERCHANT_STATUS',
  EDITING_MERCHANT_STATUS: 'EDITING_MERCHANT_STATUS',
  EDIT_MERCHANT_STATUS_SUCCESS: 'EDIT_MERCHANT_STATUS_SUCCESS',
  EDIT_MERCHANT_STATUS_FAILED: 'EDIT_MERCHANT_STATUS_FAILED',

  CHANGE_STATUS_MERCHANT_STATUS: 'CHANGE_STATUS_MERCHANT_STATUS',
  CHANGING_STATUS_MERCHANT_STATUS: 'CHANGING_STATUS_MERCHANT_STATUS',
  CHANGE_STATUS_MERCHANT_STATUS_SUCCESS: 'CHANGE_STATUS_MERCHANT_STATUS_SUCCESS',
  CHANGE_STATUS_MERCHANT_STATUS_FAILED: 'CHANGE_STATUS_MERCHANT_STATUS_FAILED',

  REORDER_MERCHANT_STATUS_DATA: 'REORDER_MERCHANT_STATUS_DATA',
  REORDERING_MERCHANT_STATUS_DATA: 'REORDERING_MERCHANT_STATUS_DATA',
  REORDER_MERCHANT_STATUS_DATA_SUCCESS: 'REORDER_MERCHANT_STATUS_DATA_SUCCESS',
  REORDER_MERCHANT_STATUS_DATA_FAILED: 'REORDER_MERCHANT_STATUS_DATA_FAILED',

  EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS: 'EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS',
  EDITING_MERCHANT_STATUS_NOTIFICATION_SETTINGS: 'EDITING_MERCHANT_STATUS_NOTIFICATION_SETTINGS',
  EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_SUCCESS:
    'EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_SUCCESS',
  EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED:
    'EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS_FAILED',
  // end: merchant status

  // start: lead monitoring
  FETCH_LEAD_MONITORING: 'FETCH_LEAD_MONITORING',
  FETCHING_LEAD_MONITORING: 'FETCHING_LEAD_MONITORING',
  FETCH_LEAD_MONITORING_SUCCESS: 'FETCH_LEAD_MONITORING_SUCCESS',
  FETCH_LEAD_MONITORING_FAILED: 'FETCH_LEAD_MONITORING_FAILED',
  // end: lead monitoring

  FETCH_LEAD_LOGS: 'FETCH_LEAD_LOGS',
  LOADING_MORE_LEAD_LOGS: 'LOADING_MORE_LEAD_LOGS',
  FETCHING_LEAD_LOGS: 'FETCHING_LEAD_LOGS',
  FETCH_LEAD_LOGS_SUCCESS: 'FETCH_LEAD_LOGS_SUCCESS',
  FETCH_LEAD_LOGS_FAILED: 'FETCH_LEAD_LOGS_FAILED',
  RESET_LEAD_LOGS: 'RESET_LEAD_LOGS',

  CHANGE_STATUS_NURTURING: 'CHANGE_STATUS_NURTURING',
  CHANGING_STATUS_NURTURING: 'CHANGING_STATUS_NURTURING',
  CHANGE_STATUS_NURTURING_SUCCESS: 'CHANGE_STATUS_NURTURING_SUCCESS',
  CHANGE_STATUS_NURTURING_FAILED: 'CHANGE_STATUS_NURTURING_FAILED',

  FETCH_ALL_LEADS_NURTURING: 'FETCH_ALL_LEADS_NURTURING',
  FETCHING_ALL_LEADS_NURTURING: 'FETCHING_ALL_LEADS_NURTURING',
  FETCH_ALL_LEADS_NURTURING_SUCCESS: 'FETCH_ALL_LEADS_NURTURING_SUCCESS',
  FETCH_ALL_LEADS_NURTURING_FAILED: 'FETCH_ALL_LEADS_NURTURING_FAILED',
  LOADING_MORE_LEADS_NURTURING: 'LOADING_MORE_LEADS_NURTURING',

  FETCH_LEAD_NURTURING_BY_ID: 'FETCH_LEAD_NURTURING_BY_ID',
  FETCHING_LEAD_NURTURING_BY_ID: 'FETCHING_LEAD_NURTURING_BY_ID',
  FETCH_LEAD_NURTURING_BY_ID_SUCCESS: 'FETCH_LEAD_NURTURING_BY_ID_SUCCESS',
  FETCH_LEAD_NURTURING_BY_ID_FAILED: 'FETCH_LEAD_NURTURING_BY_ID_FAILED',
  RESET_ACTIVE_LEAD_NURTURING_BY_ID: 'RESET_ACTIVE_LEAD_NURTURING_BY_ID',

  FETCH_LEAD_NURTURING_REQUEST_BY_ID: 'FETCH_LEAD_NURTURING_REQUEST_BY_ID',
  FETCHING_LEAD_NURTURING_REQUEST_BY_ID: 'FETCHING_LEAD_NURTURING_REQUEST_BY_ID',
  FETCH_LEAD_NURTURING_REQUEST_BY_ID_SUCCESS: 'FETCH_LEAD_NURTURING_REQUEST_BY_ID_SUCCESS',
  FETCH_LEAD_NURTURING_REQUEST_BY_ID_FAILED: 'FETCH_LEAD_NURTURING_REQUEST_BY_ID_FAILED',
  RESET_ACTIVE_LEAD_NURTURING_REQUEST_BY_ID: 'RESET_ACTIVE_LEAD_NURTURING_REQUEST_BY_ID',

  UPDATE_LEAD_NURTURING: 'UPDATE_LEAD_NURTURING',
  UPDATING_LEAD_NURTURING: 'UPDATING_LEAD_NURTURING',
  UPDATE_LEAD_NURTURING_SUCCESS: 'UPDATE_LEAD_NURTURING_SUCCESS',
  UPDATE_LEAD_NURTURING_FAILED: 'UPDATE_LEAD_NURTURING_FAILED',

  TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST: 'TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST',
  TRIGGERING_LEAD_NURTURING_EXEMPTION_REQUEST: 'TRIGGERING_LEAD_NURTURING_EXEMPTION_REQUEST',
  TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_SUCCESS:
    'TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_SUCCESS',
  TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_FAILED:
    'TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST_FAILED',

  ADD_INTEGRATION_FORM_REQUEST: 'ADD_INTEGRATION_FORM_REQUEST',
  ADDING_INTEGRATION_FORM_REQUEST: 'ADDING_INTEGRATION_FORM_REQUEST',
  ADD_INTEGRATION_FORM_REQUEST_SUCCESS: 'ADD_INTEGRATION_FORM_REQUEST_SUCCESS',
  ADD_INTEGRATION_FORM_REQUEST_FAILED: 'ADD_INTEGRATION_FORM_REQUEST_FAILED',

  FETCH_LEAD_DISCUSSIONS: 'FETCH_LEAD_DISCUSSIONS',
  SET_LEAD_DISCUSSION_VALUE: 'SET_LEAD_DISCUSSION_VALUE',
  LOAD_MORE_LEAD_DISCUSSIONS: 'LOAD_MORE_LEAD_DISCUSSIONS',
  FETCHING_LEAD_DISCUSSIONS: 'FETCHING_LEAD_DISCUSSIONS',
  FETCH_LEAD_DISCUSSIONS_SUCCESS: 'FETCH_LEAD_DISCUSSIONS_SUCCESS',
  FETCH_LEAD_DISCUSSIONS_FAILED: 'FETCH_LEAD_DISCUSSIONS_FAILED',

  STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD: 'STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD',
  STORING_ATTACHED_LEAD_FILES_FOR_UPLOAD: 'STORING_ATTACHED_LEAD_FILES_FOR_UPLOAD',
  STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_SUCCESS: 'STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_SUCCESS',
  STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_FAILED: 'STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD_FAILED',

  STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD:
    'STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD',
  STORING_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD:
    'STORING_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD',
  STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_SUCCESS:
    'STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_SUCCESS',
  STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_FAILED:
    'STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD_FAILED',

  STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD: 'STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD',
  STORING_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD:
    'STORING_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD',
  STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_SUCCESS:
    'STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_SUCCESS',
  STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_FAILED:
    'STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD_FAILED',

  LIKE_LEAD_DISCUSSION_DATA: 'LIKE_LEAD_DISCUSSION_DATA',
  LIKE_LEAD_DISCUSSION_CURRENT_ID: 'LIKE_LEAD_DISCUSSION_CURRENT_ID',
  LIKING_LEAD_DISCUSSION_DATA: 'LIKING_LEAD_DISCUSSION_DATA',
  LIKE_LEAD_DISCUSSION_DATA_SUCCESS: 'LIKE_LEAD_DISCUSSION_DATA_SUCCESS',
  LIKE_LEAD_DISCUSSION_DATA_FAILED: 'LIKE_LEAD_DISCUSSION_DATA_FAILED',

  SEND_LEAD_DISCUSSION_ITEM: 'SEND_LEAD_DISCUSSION_ITEM',
  SENDING_LEAD_DISCUSSION_ITEM: 'SENDING_LEAD_DISCUSSION_ITEM',
  SEND_LEAD_DISCUSSION_ITEM_SUCCESS: 'SEND_LEAD_DISCUSSION_ITEM_SUCCESS',
  SEND_LEAD_DISCUSSION_ITEM_FAILED: 'SEND_LEAD_DISCUSSION_ITEM_FAILED',

  DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT: 'DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT',
  DOWNLOADING_LEAD_DISCUSSION_ATTACHMENT: 'DOWNLOADING_LEAD_DISCUSSION_ATTACHMENT',
  DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_SUCCESS: 'DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_SUCCESS',
  DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED: 'DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT_FAILED',

  DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT: 'DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT',
  DOWNLOADING_LEAD_CHANGE_STATUS_ATTACHMENT: 'DOWNLOADING_LEAD_CHANGE_STATUS_ATTACHMENT',
  DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_SUCCESS: 'DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_SUCCESS',
  DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED: 'DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT_FAILED',

  DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT: 'DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT',
  DOWNLOADING_LEAD_ACTIVITY_ATTACHMENT: 'DOWNLOADING_LEAD_ACTIVITY_ATTACHMENT',
  DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_SUCCESS: 'DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_SUCCESS',
  DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED: 'DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT_FAILED',

  FILTER_SEARCH_RELATIONS_MANAGER: 'FILTER_SEARCH_RELATIONS_MANAGER',
  FILTER_RELATIONS_MANAGER: 'FILTER_RELATIONS_MANAGER',
  CHANGE_RELATIONS_MANAGER_VIEW: 'CHANGE_RELATIONS_MANAGER_VIEW',

  CHANGE_STATUS_SANITATION: 'CHANGE_STATUS_SANITATION',
  CHANGING_STATUS_SANITATION: 'CHANGING_STATUS_SANITATION',
  CHANGE_STATUS_SANITATION_SUCCESS: 'CHANGE_STATUS_SANITATION_SUCCESS',
  CHANGE_STATUS_SANITATION_FAILED: 'CHANGE_STATUS_SANITATION_FAILED',

  FETCH_ALL_LEADS_SANITATION: 'FETCH_ALL_LEADS_SANITATION',
  FETCHING_ALL_LEADS_SANITATION: 'FETCHING_ALL_LEADS_SANITATION',
  FETCH_ALL_LEADS_SANITATION_SUCCESS: 'FETCH_ALL_LEADS_SANITATION_SUCCESS',
  FETCH_ALL_LEADS_SANITATION_FAILED: 'FETCH_ALL_LEADS_SANITATION_FAILED',
  LOADING_MORE_LEADS_SANITATION: 'LOADING_MORE_LEADS_SANITATION',

  FETCH_LEAD_SANITATION_BY_ID: 'FETCH_LEAD_SANITATION_BY_ID',
  FETCHING_LEAD_SANITATION_BY_ID: 'FETCHING_LEAD_SANITATION_BY_ID',
  FETCH_LEAD_SANITATION_BY_ID_SUCCESS: 'FETCH_LEAD_SANITATION_BY_ID_SUCCESS',
  FETCH_LEAD_SANITATION_BY_ID_FAILED: 'FETCH_LEAD_SANITATION_BY_ID_FAILED',
  RESET_ACTIVE_LEAD_SANITATION_BY_ID: 'RESET_ACTIVE_LEAD_SANITATION_BY_ID',

  UPDATE_LEAD_SANITATION: 'UPDATE_LEAD_SANITATION',
  UPDATING_LEAD_SANITATION: 'UPDATING_LEAD_SANITATION',
  UPDATE_LEAD_SANITATION_SUCCESS: 'UPDATE_LEAD_SANITATION_SUCCESS',
  UPDATE_LEAD_SANITATION_FAILED: 'UPDATE_LEAD_SANITATION_FAILED',

  FETCH_RELATIONS_MANAGER_LEAD_LOGS: 'FETCH_RELATIONS_MANAGER_LEAD_LOGS',
  LOADING_MORE_RELATIONS_MANAGER_LEAD_LOGS: 'LOADING_MORE_RELATIONS_MANAGER_LEAD_LOGS',
  FETCHING_RELATIONS_MANAGER_LEAD_LOGS: 'FETCHING_RELATIONS_MANAGER_LEAD_LOGS',
  FETCH_RELATIONS_MANAGER_LEAD_LOGS_SUCCESS: 'FETCH_RELATIONS_MANAGER_LEAD_LOGS_SUCCESS',
  FETCH_RELATIONS_MANAGER_LEAD_LOGS_FAILED: 'FETCH_RELATIONS_MANAGER_LEAD_LOGS_FAILED',
  PUSH_RELATIONS_MANAGER_LEAD_LOGS: 'PUSH_RELATIONS_MANAGER_LEAD_LOGS',
  RESET_RELATIONS_MANAGER_LEAD_LOGS: 'RESET_RELATIONS_MANAGER_LEAD_LOGS',

  // START: Lead Nurturing
  STORE_EXEMPTION_FILES_FOR_UPLOAD: 'STORE_EXEMPTION_FILES_FOR_UPLOAD',
  STORING_EXEMPTION_FILES_FOR_UPLOAD: 'STORING_EXEMPTION_FILES_FOR_UPLOAD',
  STORE_EXEMPTION_FILES_FOR_UPLOAD_SUCCESS: 'STORE_EXEMPTION_FILES_FOR_UPLOAD_SUCCESS',
  STORE_EXEMPTION_FILES_FOR_UPLOAD_FAILED: 'STORE_EXEMPTION_FILES_FOR_UPLOAD_FAILED',

  MANAGE_EXEMPTION_FILES: 'MANAGE_EXEMPTION_FILES',
  MANAGING_EXEMPTION_FILES: 'MANAGING_EXEMPTION_FILES',
  MANAGE_EXEMPTION_FILES_SUCCESS: 'MANAGE_EXEMPTION_FILES_SUCCESS',
  MANAGE_EXEMPTION_FILES_FAILED: 'MANAGE_EXEMPTION_FILES_FAILED',

  // START: Merchant Management
  FETCH_ALL_MERCHANT_MANAGEMENT: 'FETCH_ALL_MERCHANT_MANAGEMENT',
  FETCHING_ALL_MERCHANT_MANAGEMENT: 'FETCHING_ALL_MERCHANT_MANAGEMENT',
  FETCH_ALL_MERCHANT_MANAGEMENT_SUCCESS: 'FETCH_ALL_MERCHANT_MANAGEMENT_SUCCESS',
  FETCH_ALL_MERCHANT_MANAGEMENT_FAILED: 'FETCH_ALL_MERCHANT_MANAGEMENT_FAILED',
  LOADING_MORE_MERCHANT_MANAGEMENT: 'LOADING_MORE_MERCHANT_MANAGEMENT',

  FETCH_MERCHANT_MANAGEMENT_BY_ID: 'FETCH_MERCHANT_MANAGEMENT_BY_ID',
  FETCHING_MERCHANT_MANAGEMENT_BY_ID: 'FETCHING_MERCHANT_MANAGEMENT_BY_ID',
  FETCH_MERCHANT_MANAGEMENT_BY_ID_SUCCESS: 'FETCH_MERCHANT_MANAGEMENT_BY_ID_SUCCESS',
  FETCH_MERCHANT_MANAGEMENT_BY_ID_FAILED: 'FETCH_MERCHANT_MANAGEMENT_BY_ID_FAILED',
  RESET_ACTIVE_MERCHANT_MANAGEMENT_BY_ID: 'RESET_ACTIVE_MERCHANT_MANAGEMENT_BY_ID',

  FETCH_MIS_DATA_BY_ID: 'FETCH_MIS_DATA_BY_ID',
  FETCHING_MIS_DATA_BY_ID: 'FETCHING_MIS_DATA_BY_ID',
  FETCH_MIS_DATA_BY_ID_SUCCESS: 'FETCH_MIS_DATA_BY_ID_SUCCESS',
  FETCH_MIS_DATA_BY_ID_FAILED: 'FETCH_MIS_DATA_BY_ID_FAILED',

  COMPLETE_SALES_REQ_INFO: 'COMPLETE_SALES_REQ_INFO',
  COMPLETING_SALES_REQ_INFO: 'COMPLETING_SALES_REQ_INFO',
  COMPLETE_SALES_REQ_INFO_SUCCESS: 'COMPLETE_SALES_REQ_INFO_SUCCESS',
  COMPLETE_SALES_REQ_INFO_FAILED: 'COMPLETE_SALES_REQ_INFO_FAILED',

  STORE_SIGNED_PROPOSAL_FOR_UPLOAD: 'STORE_SIGNED_PROPOSAL_FOR_UPLOAD',
  STORING_SIGNED_PROPOSAL_FOR_UPLOAD: 'STORING_SIGNED_PROPOSAL_FOR_UPLOAD',
  STORE_SIGNED_PROPOSAL_FOR_UPLOAD_SUCCESS: 'STORE_SIGNED_PROPOSAL_FOR_UPLOAD_SUCCESS',
  STORE_SIGNED_PROPOSAL_FOR_UPLOAD_FAILED: 'STORE_SIGNED_PROPOSAL_FOR_UPLOAD_FAILED',

  DOWNLOAD_NURTURING_EXEMPTION_FILE: 'DOWNLOAD_NURTURING_EXEMPTION_FILE',
  DOWNLOADING_NURTURING_EXEMPTION_FILE: 'DOWNLOADING_NURTURING_EXEMPTION_FILE',
  DOWNLOAD_NURTURING_EXEMPTION_FILE_SUCCESS: 'DOWNLOAD_NURTURING_EXEMPTION_FILE_SUCCESS',
  DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED: 'DOWNLOAD_NURTURING_EXEMPTION_FILE_FAILED',

  DOWNLOAD_SIGNED_PROPOSAL_FILE: 'DOWNLOAD_SIGNED_PROPOSAL_FILE',
  DOWNLOADING_SIGNED_PROPOSAL_FILE: 'DOWNLOADING_SIGNED_PROPOSAL_FILE',
  DOWNLOAD_SIGNED_PROPOSAL_FILE_SUCCESS: 'DOWNLOAD_SIGNED_PROPOSAL_FILE_SUCCESS',
  DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED: 'DOWNLOAD_SIGNED_PROPOSAL_FILE_FAILED',

  STORE_SIGNED_PSA_FOR_UPLOAD: 'STORE_SIGNED_PSA_FOR_UPLOAD',
  STORING_SIGNED_PSA_FOR_UPLOAD: 'STORING_SIGNED_PSA_FOR_UPLOAD',
  STORE_SIGNED_PSA_FOR_UPLOAD_SUCCESS: 'STORE_SIGNED_PSA_FOR_UPLOAD_SUCCESS',
  STORE_SIGNED_PSA_FOR_UPLOAD_FAILED: 'STORE_SIGNED_PSA_FOR_UPLOAD_FAILED',

  DOWNLOAD_SIGNED_PSA_FILE: 'DOWNLOAD_SIGNED_PSA_FILE',
  DOWNLOADING_SIGNED_PSA_FILE: 'DOWNLOADING_SIGNED_PSA_FILE',
  DOWNLOAD_SIGNED_PSA_FILE_SUCCESS: 'DOWNLOAD_SIGNED_PSA_FILE_SUCCESS',
  DOWNLOAD_SIGNED_PSA_FILE_FAILED: 'DOWNLOAD_SIGNED_PSA_FILE_FAILED',

  STORE_VAT_EXEMPTION_FOR_UPLOAD: 'STORE_VAT_EXEMPTION_FOR_UPLOAD',
  STORING_VAT_EXEMPTION_FOR_UPLOAD: 'STORING_VAT_EXEMPTION_FOR_UPLOAD',
  STORE_VAT_EXEMPTION_FOR_UPLOAD_SUCCESS: 'STORE_VAT_EXEMPTION_FOR_UPLOAD_SUCCESS',
  STORE_VAT_EXEMPTION_FOR_UPLOAD_FAILED: 'STORE_VAT_EXEMPTION_FOR_UPLOAD_FAILED',

  DOWNLOAD_VAT_EXEMPTION_FILE: 'DOWNLOAD_VAT_EXEMPTION_FILE',
  DOWNLOADING_VAT_EXEMPTION_FILE: 'DOWNLOADING_VAT_EXEMPTION_FILE',
  DOWNLOAD_VAT_EXEMPTION_FILE_SUCCESS: 'DOWNLOAD_VAT_EXEMPTION_FILE_SUCCESS',
  DOWNLOAD_VAT_EXEMPTION_FILE_FAILED: 'DOWNLOAD_VAT_EXEMPTION_FILE_FAILED',

  STORE_WIRED_TRANSACTION_FOR_UPLOAD: 'STORE_WIRED_TRANSACTION_FOR_UPLOAD',
  STORING_WIRED_TRANSACTION_FOR_UPLOAD: 'STORING_WIRED_TRANSACTION_FOR_UPLOAD',
  STORE_WIRED_TRANSACTION_FOR_UPLOAD_SUCCESS: 'STORE_WIRED_TRANSACTION_FOR_UPLOAD_SUCCESS',
  STORE_WIRED_TRANSACTION_FOR_UPLOAD_FAILED: 'STORE_WIRED_TRANSACTION_FOR_UPLOAD_FAILED',

  DOWNLOAD_WIRED_TRANSACTION_FILE: 'DOWNLOAD_WIRED_TRANSACTION_FILE',
  DOWNLOADING_WIRED_TRANSACTION_FILE: 'DOWNLOADING_WIRED_TRANSACTION_FILE',
  DOWNLOAD_WIRED_TRANSACTION_FILE_SUCCESS: 'DOWNLOAD_WIRED_TRANSACTION_FILE_SUCCESS',
  DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED: 'DOWNLOAD_WIRED_TRANSACTION_FILE_FAILED',

  TRIGGER_INVOICE_CREATION: 'TRIGGER_INVOICE_CREATION',
  TRIGGERING_INVOICE_CREATION: 'TRIGGERING_INVOICE_CREATION',
  TRIGGER_INVOICE_CREATION_SUCCESS: 'TRIGGER_INVOICE_CREATION_SUCCESS',
  TRIGGER_INVOICE_CREATION_FAILED: 'TRIGGER_INVOICE_CREATION_FAILED',

  RESEND_MIS_LINK: 'RESEND_MIS_LINK',
  RESENDING_MIS_LINK: 'RESENDING_MIS_LINK',
  RESEND_MIS_LINK_SUCCESS: 'RESEND_MIS_LINK_SUCCESS',
  RESEND_MIS_LINK_FAILED: 'RESEND_MIS_LINK_FAILED',

  // END: Merchant Management

  // START: Template Lead
  FETCH_TEMPLATE_LEAD_DATA: 'FETCH_TEMPLATE_LEAD_DATA',
  FETCHING_TEMPLATE_LEAD_DATA: 'FETCHING_TEMPLATE_LEAD_DATA',
  FETCH_TEMPLATE_LEAD_DATA_SUCCESS: 'FETCH_TEMPLATE_LEAD_DATA_SUCCESS',
  FETCH_TEMPLATE_LEAD_DATA_FAILED: 'FETCH_TEMPLATE_LEAD_DATA_FAILED',

  ADD_TEMPLATE_LEAD_DATA: 'ADD_TEMPLATE_LEAD_DATA',
  ADDING_TEMPLATE_LEAD_DATA: 'ADDING_TEMPLATE_LEAD_DATA',
  ADD_TEMPLATE_LEAD_DATA_SUCCESS: 'ADD_TEMPLATE_LEAD_DATA_SUCCESS',
  ADD_TEMPLATE_LEAD_DATA_FAILED: 'ADD_TEMPLATE_LEAD_DATA_FAILED',

  EDIT_TEMPLATE_LEAD_DATA: 'EDIT_TEMPLATE_LEAD_DATA',
  EDITING_TEMPLATE_LEAD_DATA: 'EDITING_TEMPLATE_LEAD_DATA',
  EDIT_TEMPLATE_LEAD_DATA_SUCCESS: 'EDIT_TEMPLATE_LEAD_DATA_SUCCESS',
  EDIT_TEMPLATE_LEAD_DATA_FAILED: 'EDIT_TEMPLATE_LEAD_DATA_FAILED',
  // END: Template Lead

  SEND_MIS_FORM_LINK: 'SEND_MIS_FORM_LINK',
  SENDING_MIS_FORM_LINK: 'SENDING_MIS_FORM_LINK',
  SEND_MIS_FORM_LINK_SUCCESS: 'SEND_MIS_FORM_LINK_SUCCESS',
  SEND_MIS_FORM_LINK_FAILED: 'SEND_MIS_FORM_LINK_FAILED',

  DOWNLOAD_LEAD_TEMPLATE_FILE: 'DOWNLOAD_LEAD_TEMPLATE_FILE',
  DOWNLOADING_LEAD_TEMPLATE_FILE: 'DOWNLOADING_LEAD_TEMPLATE_FILE',
  DOWNLOAD_LEAD_TEMPLATE_FILE_SUCCESS: 'DOWNLOAD_LEAD_TEMPLATE_FILE_SUCCESS',
  DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED: 'DOWNLOAD_LEAD_TEMPLATE_FILE_FAILED',

  REQUEST_VAT_EXEMPT_REVERSAL_SALES: 'REQUEST_VAT_EXEMPT_REVERSAL_SALES',
  REQUESTING_VAT_EXEMPT_REVERSAL_SALES: 'REQUESTING_VAT_EXEMPT_REVERSAL_SALES',
  REQUEST_VAT_EXEMPT_REVERSAL_SALES_SUCCESS: 'REQUEST_VAT_EXEMPT_REVERSAL_SALES_SUCCESS',
  REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED: 'REQUEST_VAT_EXEMPT_REVERSAL_SALES_FAILED',

  FETCH_REVERSAL_REQUEST_BY_ID_SALES: 'FETCH_REVERSAL_REQUEST_BY_ID',
  FETCHING_REVERSAL_REQUEST_BY_ID_SALES: 'FETCHING_REVERSAL_REQUEST_BY_ID_SALES',
  FETCH_REVERSAL_REQUEST_BY_ID_SALES_SUCCESS: 'FETCH_REVERSAL_REQUEST_BY_ID_SALES_SUCCESS',
  FETCH_REVERSAL_REQUEST_BY_ID_SALES_FAILED: 'FETCH_REVERSAL_REQUEST_BY_ID_SALES_FAILED',

  requestVatExemptReversalSales: (urls, payload) => ({
    type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SALES,
    urls,
    payload
  }),

  fetchReversalRequestByIDSales: (id) => ({
    type: actions.FETCH_REVERSAL_REQUEST_BY_ID_SALES,
    id
  }),

  resetAccountOfficerRedux: payload => ({
    type: actions.RESET_ACCOUNT_OFFICER_REDUX,
    payload
  }),

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  selectCurrentDate: payload => ({
    type: actions.SELECT_CALENDAR_DATE,
    payload
  }),

  isPastDate: payload => ({
    type: actions.IS_PAST_DATE,
    payload
  }),
  fetchAllAccountOfficers: payload => ({
    type: actions.FETCH_ACCOUNT_OFFICER_DATA,
    payload
  }),
  fetchMerchantStatusCount: payload => ({
    type: actions.FETCH_MERCHANT_STATUS_COUNT_DATA,
    payload
  }),
  fetchAllAccountOfficerTeam: payload => ({
    type: actions.FETCH_ACCOUNT_OFFICER_TEAM_DATA,
    payload
  }),

  addNewAccountOfficer: payload => ({
    type: actions.ADD_ACCOUNT_OFFICER_DATA,
    payload
  }),

  addNewTeam: payload => ({
    type: actions.ADD_NEW_ACCOUNT_OFFICER_TEAM_DATA,
    payload
  }),

  editAccountOfficer: (payload, id) => ({
    type: actions.EDIT_ACCOUNT_OFFICER_DATA,
    payload,
    id
  }),

  editTeamData: (payload, id) => ({
    type: actions.EDIT_ACCOUNT_OFFICER_TEAM_DATA,
    payload,
    id
  }),

  deleteAccountOfficer: payload => ({
    type: actions.DELETE_ACCOUNT_OFFICER_DATA,
    payload
  }),

  removeAccountOfficerOnTeam: (payload, id) => ({
    type: actions.DELETE_ACCOUNT_OFFICER_ON_TEAM_DATA,
    payload,
    id
  }),

  updateAccountOfficerStatus: (payload, id) => ({
    type: actions.UPDATE_ACCOUNT_OFFICER_STATUS,
    payload,
    id
  }),

  fetchAllLeadManagementDataList: (payload, pagination) => ({
    type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA,
    payload,
    pagination
  }),

  fetchLeadMerchantDataListByMQTT: payload => ({
    type: actions.FETCH_LEAD_MANAGEMENT_LIST_DATA_BY_MQTT,
    payload
  }),

  fetchFilteredMerchantDataList: (payload, pagination) => ({
    type: actions.FETCH_FILTERED_LEAD_MANAGEMENT_LIST_DATA,
    payload,
    pagination
  }),

  fetchAllLeadManagementDataCalendar: payload => ({
    type: actions.FETCH_LEAD_MANAGEMENT_CALENDAR_DATA,
    payload
  }),

  fetchAllLeadManagementDataReport: payload => ({
    type: actions.FETCH_LEAD_MANAGEMENT_REPORT_DATA,
    payload
  }),

  updateLeadMerchantListStatus: (payload, id, currentFilter) => ({
    type: actions.UPDATE_LEAD_MERCHANT_LIST_DATA,
    payload,
    id,
    currentFilter
  }),

  addLeadMerchantData: (payload, currentFilter) => ({
    type: actions.ADD_LEAD_MERCHANT_DATA,
    payload,
    currentFilter
  }),

  addFarmingLeadMerchantData: (payload, currentFilter) => ({
    type: actions.ADD_FARMING_LEAD_MERCHANT_DATA,
    payload,
    currentFilter
  }),

  fetchAllMerchantData: payload => ({
    type: actions.FETCH_ALL_MERCHANT_DATA,
    payload
  }),

  addAppointmentData: (urls, payload, currentDate) => ({
    type: actions.ADD_APPOINTMENT_DATA,
    urls,
    payload,
    currentDate
  }),

  fetchTargetProjectionsData: payload => ({
    type: actions.FETCH_TARGET_PROJECTIONS_DATA,
    payload
  }),

  fetchTargetProjectionsDataByTeam: payload => ({
    type: actions.FETCH_TARGET_PROJECTIONS_DATA_BY_TEAM,
    payload
  }),
  addMonthlyTarget: payload => ({
    type: actions.ADD_MONTHLY_TARGET_DATA,
    payload
  }),

  addCustomerVisit: payload => ({
    type: actions.ADD_CUSTOMER_VISIT_DATA,
    payload
  }),

  editAppointmentData: (urls, payload, id, currentFilter) => ({
    type: actions.EDIT_APPOINTMENT_DATA,
    urls,
    payload,
    id,
    currentFilter
  }),

  updateMonthlyTarget: (payload, id) => ({
    type: actions.UPDATE_MONTHLY_TARGET_DATA,
    payload,
    id
  }),
  updateCustomerVisit: (payload, id) => ({
    type: actions.UPDATE_CUSTOMER_VISIT_DATA,
    payload,
    id
  }),
  completionOfMerchantDataProcess: (payload, id, filter) => ({
    type: actions.COMPLETE_MERCHANT_DETAILS,
    payload,
    id,
    filter
  }),
  completionOfFarmingMerchantDataProcess: (payload, id, filter) => ({
    type: actions.COMPLETE_FARMING_MERCHANT_DETAILS,
    payload,
    id,
    filter
  }),
  passStatusRequirementData: (payload, id) => ({
    type: actions.PASS_STATUS_REQUIREMENT_DATA_DATA,
    payload,
    id
  }),
  resetTargetProjectionsData: () => ({
    type: actions.RESET_TARGET_PROJECTIONS_DATA
  }),

  fetchRequirementByMerchantID: payload => ({
    type: actions.FETCH_REQUIREMENT_BY_MERCHANT_ID_DATA,
    payload
  }),
  fetchStoryByMerhcantID: (payload, pagination) => ({
    type: actions.FETCH_STORY_BY_MERCHANT_ID_DATA,
    payload,
    pagination
  }),
  checkRequirmentStatus: (payload, id) => ({
    type: actions.CHECK_REQUIREMENT_STATUS_BY_MERCHANT_ID_DATA,
    payload,
    id
  }),

  downloadRequirementFileData: payload => ({
    type: actions.DOWNLOAD_REQUIREMENT_FILE_DATA,
    payload
  }),

  resetFileDataFromStorage: () => ({
    type: actions.REMOVE_REQUIREMENT_FILE_DATA_STORAGE
  }),

  fetchMerchantServices: payload => ({
    type: actions.FETCH_MERCHANT_SERVICES,
    payload
  }),

  fetchInstallmentBankConfigurations: payload => ({
    type: actions.FETCH_INSTALLMENT_BANK_CONFIGURATIONS,
    payload
  }),

  fetchMerchantStatus: payload => ({
    type: actions.FETCH_MERCHANT_STATUS,
    payload
  }),

  addNewMerchantStatus: payload => ({
    type: actions.ADD_MERCHANT_STATUS,
    payload
  }),

  editMerchantStatus: (payload, id) => ({
    type: actions.EDIT_MERCHANT_STATUS,
    payload,
    id
  }),

  changeMerchantStatusStatus: (payload, id) => ({
    type: actions.CHANGE_STATUS_MERCHANT_STATUS
  }),

  fetchLeadMonitoring: (payload) => ({
    type: actions.FETCH_LEAD_MONITORING,
    payload
  }),

  addLeads: payload => ({
    type: actions.ADD_LEADS,
    payload
  }),

  addLeadsByRM: payload => ({
    type: actions.ADD_LEADS_BY_RM,
    payload
  }),

  addLeadsFromSuspectedDuplicates: payload => ({
    type: actions.ADD_LEADS_FROM_SUSPECTED_DUPLICATES,
    payload
  }),

  rejectLeadsFromSuspectedDuplicates: payload => ({
    type: actions.REJECT_LEADS_FROM_SUSPECTED_DUPLICATES,
    payload
  }),

  toggleLeadsSuspectedDuplicates: payload => ({
    type: actions.TOGGLE_LEADS_SUSPECTED_DUPLICATES,
    payload
  }),

  approveLeadSanitation: (payload, id) => ({
    type: actions.APPROVE_LEAD_SANITATION,
    payload,
    id
  }),

  approveLeadSanitationLeadsManagement: (payload, id) => ({
    type: actions.APPROVE_LEAD_SANITATION_LEADS_MANAGEMENT,
    payload,
    id
  }),

  rejectLeadSanitation: (payload, id) => ({
    type: actions.REJECT_LEAD_SANITATION,
    payload,
    id
  }),

  rejectLeadSanitationLeadsManagement: (payload, id) => ({
    type: actions.REJECT_LEAD_SANITATION_LEADS_MANAGEMENT,
    payload,
    id
  }),

  fetchAllLeads: (payload) => ({
    type: actions.FETCH_ALL_LEADS,
    payload
  }),

  fetchAllLeadsUploadedFileData: (payload) => ({
    type: actions.FETCH_ALL_UPLOADED_LEADS_FILE_DATA,
    payload
  }),

  fetchAllSuspectedDuplicateLeads: (payload) => ({
    type: actions.FETCH_ALL_SUSPECTED_DUPLICATE_LEADS,
    payload
  }),

  fetchLeadsById: id => ({
    type: actions.FETCH_LEADS_BY_ID,
    id
  }),

  editLeads: (payload, id) => ({
    type: actions.EDIT_LEADS,
    payload,
    id
  }),

  editLeadSanitation: (payload, id) => ({
    type: actions.EDIT_LEAD_SANITATION,
    payload,
    id
  }),

  reorderMerchantStatus: payload => ({
    type: actions.REORDER_MERCHANT_STATUS_DATA,
    payload
  }),

  editMerchantStatusNotificationSettings: (payload, id) => ({
    type: actions.EDIT_MERCHANT_STATUS_NOTIFICATION_SETTINGS,
    payload,
    id
  }),

  resetLeadById: () => ({
    type: actions.RESET_ACTIVE_LEAD_BY_ID
  }),

  fetchLeadLogs: (id, pagination) => ({
    type: actions.FETCH_LEAD_LOGS,
      id,
      pagination
  }),

  changeStatusNurturing: payload => ({
    type: actions.CHANGE_STATUS_NURTURING,
    payload
  }),

  fetchAllLeadsNurturing: (payload, currentList) => ({
    type: actions.FETCH_ALL_LEADS_NURTURING,
    payload,
    currentList
  }),

  fetchLeadNurturingById: id => ({
    type: actions.FETCH_LEAD_NURTURING_BY_ID,
    id
  }),

  fetchLeadNurturingRequestById: payload => ({
    type: actions.FETCH_LEAD_NURTURING_REQUEST_BY_ID,
    payload
  }),

  updateLeadNurturing: (urls, payload, id) => ({
    type: actions.UPDATE_LEAD_NURTURING,
    urls,
    payload,
    id
  }),

  triggerLeadNurturingExemptionRequest: (payload, id) => ({
    type: actions.TRIGGER_LEAD_NURTURING_EXEMPTION_REQUEST,
    payload,
    id
  }),

  addIntegrationFormRequest: (urls, payload, id) => ({
    type: actions.ADD_INTEGRATION_FORM_REQUEST,
    urls,
    payload,
    id
  }),

  getS3UrlsForLeadFiles: (key, files) => ({
    type: actions.STORE_ATTACHED_LEAD_FILES_FOR_UPLOAD,
    key,
    files
  }),

  getS3UrlsForLeadChangeStatusFiles: (key, files) => ({
    type: actions.STORE_ATTACHED_LEAD_CHANGE_STATUS_FILES_FOR_UPLOAD,
    key,
    files
  }),

  getS3UrlsForLeadActivityFiles: (key, files) => ({
    type: actions.STORE_ATTACHED_LEAD_ACTIVITY_FILES_FOR_UPLOAD,
    key,
    files
  }),

  resetS3UrlsForIRFProdProofTestingFiles: () => ({
    type: actions.RESET_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD
  }),

  sendLeadDiscussion: (urls, payload) => ({
    type: actions.SEND_LEAD_DISCUSSION_ITEM,
    urls,
    payload
  }),

  likeLeadDiscussion: (id, payload) => ({
    type: actions.LIKE_LEAD_DISCUSSION_DATA,
    id,
    payload
  }),

  fetchLeadDiscussions: (payload, currentList) => ({
    type: actions.FETCH_LEAD_DISCUSSIONS,
    payload,
    currentList
  }),

  downloadLeadAttachment: payload => ({
    type: actions.DOWNLOAD_LEAD_DISCUSSION_ATTACHMENT,
    payload
  }),

  downloadLeadChangeStatusAttachment: payload => ({
    type: actions.DOWNLOAD_LEAD_CHANGE_STATUS_ATTACHMENT,
    payload
  }),

  downloadLeadActivityAttachment: payload => ({
    type: actions.DOWNLOAD_LEAD_ACTIVITY_ATTACHMENT,
    payload
  }),

  filterSearchRelationsManager: payload => ({
    type: actions.FILTER_SEARCH_RELATIONS_MANAGER,
    payload
  }),

  filterRelationsManager: payload => ({
    type: actions.FILTER_RELATIONS_MANAGER,
    payload
  }),

  changeRelationsManagerView: payload => ({
    type: actions.CHANGE_RELATIONS_MANAGER_VIEW,
    payload
  }),

  fetchAllLeadSanitation: (payload, currentList) => ({
    type: actions.FETCH_ALL_LEADS_SANITATION,
    payload,
    currentList
  }),

  fetchLeadSanitationById: payload => ({
    type: actions.FETCH_LEAD_SANITATION_BY_ID,
    payload
  }),
  fetchRelationsManagerActivity: (payload) => ({
    type: actions.FETCH_RELATIONS_MANAGER_LEAD_LOGS,
    payload
  }),
  resetRelationsManagerActivity: () => ({
    type: actions.RESET_RELATIONS_MANAGER_LEAD_LOGS
  }),

  fetchAllMerchantManagement: (payload, currentList) => ({
    type: actions.FETCH_ALL_MERCHANT_MANAGEMENT,
    payload,
    currentList
  }),

  fetchMerchantManagementByID: payload => ({
    type: actions.FETCH_MERCHANT_MANAGEMENT_BY_ID,
    payload
  }),

  completeSalesReqInfo: (urls, payload, id) => ({
    type: actions.COMPLETE_SALES_REQ_INFO,
    urls,
    payload,
    id
  }),

  getS3UrlsSignedProposal: (key, files) => ({
    type: actions.STORE_SIGNED_PROPOSAL_FOR_UPLOAD,
    key,
    files
  }),

  downloadNurturingExemptionFile: (payload, id) => ({
    type: actions.DOWNLOAD_NURTURING_EXEMPTION_FILE,
    payload,
    id
  }),

  downloadSignedProposalFile: (payload, id) => ({
    type: actions.DOWNLOAD_SIGNED_PROPOSAL_FILE,
    payload,
    id
  }),

  getS3UrlsSignedPSA: (key, files) => ({
    type: actions.STORE_SIGNED_PSA_FOR_UPLOAD,
    key,
    files
  }),

  getS3UrlsExemptionFiles: (key, files) => ({
    type: actions.STORE_EXEMPTION_FILES_FOR_UPLOAD,
    key,
    files
  }),

  manageExemptionFiles: (urls, payload, id) => ({
    type: actions.MANAGE_EXEMPTION_FILES,
    urls,
    payload,
    id
  }),

  downloadSignedPSAFile: (payload, id) => ({
    type: actions.DOWNLOAD_SIGNED_PSA_FILE,
    payload,
    id
  }),

  getS3UrlsVatExemption: (key, files) => ({
    type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD,
    key,
    files
  }),

  downloadVatExemptionFile: (payload, id) => ({
    type: actions.DOWNLOAD_VAT_EXEMPTION_FILE,
    payload,
    id
  }),

  getS3UrlsWiredTransaction: (key, files) => ({
    type: actions.STORE_WIRED_TRANSACTION_FOR_UPLOAD,
    key,
    files
  }),

  downloadWiredTransactionFile: (payload, id) => ({
    type: actions.DOWNLOAD_WIRED_TRANSACTION_FILE,
    payload,
    id
  }),

  triggerInvoice: (payload, id) => ({
    type: actions.TRIGGER_INVOICE_CREATION,
    payload,
    id
  }),

  resendMISLink: payload => ({
    type: actions.RESEND_MIS_LINK,
    payload
  }),

  fetchAllTemplateLead: payload => ({
    type: actions.FETCH_TEMPLATE_LEAD_DATA,
    payload
  }),

  addTemplateLead: payload => ({
    type: actions.ADD_TEMPLATE_LEAD_DATA,
    payload
  }),

  editTemplateLead: (payload, id) => ({
    type: actions.EDIT_TEMPLATE_LEAD_DATA,
    payload,
    id
  }),

  sendMISFormLink: payload => ({
    type: actions.SEND_MIS_FORM_LINK,
    payload
  }),

  fetchMISDataByID: payload => ({
    type: actions.FETCH_MIS_DATA_BY_ID,
    payload
  }),

  downloadLeadTemplateFile: payload => ({
    type: actions.DOWNLOAD_LEAD_TEMPLATE_FILE,
    payload
  })
};
export default actions;
